(async function () {
  const grid = document.querySelector('.holy-1010-grid');
  if (!grid) return;
  try {
    const root = window.Shopify?.routes?.root || '/';
    const url = new URL(root + 'collections/todos-os-produtos', location.origin);
    url.searchParams.set('sort_by', 'best-selling');
    url.searchParams.set('view', 'holy-1010-ranking');
    const preview = new URLSearchParams(location.search).get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    const response = await fetch(url, {credentials: 'same-origin'});
    if (!response.ok) return;
    const data = await response.json();
    if (data.sort !== 'best-selling' || !Array.isArray(data.ids)) return;
    const ranks = new Map(data.ids.map((id, index) => [String(id), index]));
    const cards = Array.from(grid.children);
    if (!cards.every(card => ranks.has(card.dataset.productId))) return;
    const sorted = cards.slice().sort((a, b) => ranks.get(a.dataset.productId) - ranks.get(b.dataset.productId));
    if (sorted.some((card, index) => card !== cards[index])) {
      sorted.forEach(card => grid.appendChild(card));
    }
  } catch {
    // Keep the last confirmed sales order when a refresh is unavailable.
  }
})();
